import { render } from "./InfoSection.vue?vue&type=template&id=d90577e4&scoped=true&ts=true"
import script from "./InfoSection.vue?vue&type=script&lang=ts"
export * from "./InfoSection.vue?vue&type=script&lang=ts"

import "./InfoSection.vue?vue&type=style&index=0&id=d90577e4&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\102\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d90577e4"]])

export default __exports__